import { render, staticRenderFns } from "./YaneHeading.vue?vue&type=template&id=11462728&scoped=true&lang=pug&"
import script from "./YaneHeading.vue?vue&type=script&lang=js&"
export * from "./YaneHeading.vue?vue&type=script&lang=js&"
import style0 from "./YaneHeading.vue?vue&type=style&index=0&id=11462728&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11462728",
  null
  
)

export default component.exports